import batteryIcon from '../../../assets/svg/batteryLoop.svg';
import elecIcon from '../../../assets/svg/elecLoop.svg';
import gridIcon from '../../../assets/svg/gridLoop.svg';
import helpIcon from '../../../assets/svg/help.svg';
import exportIcon from '../../../assets/svg/icon/export.svg';
import importIcon from '../../../assets/svg/icon/import.svg';
import infoPrimary from '../../../assets/svg/info-primary.svg';
import inverterIcon from '../../../assets/svg/inverter.svg';
import solarIcon from '../../../assets/svg/solarLoop.svg';
import type { SVGIcons } from '../ThemeTypes';

import colors from './colors';

const icons: SVGIcons = {
  solar: solarIcon,
  battery: batteryIcon,
  batteryForEquipmentOnboarding: batteryIcon,
  grid: gridIcon,
  electricity: elecIcon,
  export: exportIcon,
  import: importIcon,
  help: helpIcon,
  inverter: inverterIcon,
  info: infoPrimary,
  styles: {
    svgIcon: {
      width: '42px',
      height: '42px',
      borderRadius: '50%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      marginBottom: '8px',
      marginRight: 'auto',
      marginLeft: 'auto',
      '${min.sm}': {
        width: '60px',
        height: '60px',
        marginBottom: '0',
        marginRight: '16px',
      },
    },
    gridIcon: {
      border: `2px solid ${colors.icons.gridIconBorder}`,
      background: colors.icons.gridIconBackground,
      img: {
        width: '22px',
        '${min.sm}': {
          width: '31px',
        },
      },
    },
    consumptionIcon: {
      background: colors.icons.consumptionIconBackground,
      img: {
        width: '17px',
        '${min.sm}': {
          width: '17px',
        },
      },
    },
    solarIcon: {
      background: colors.icons.solarIconBackground,
      img: {
        width: '28px',
        '${min.sm}': {
          width: '38px',
        },
      },
    },
    batteryIcon: {
      background: colors.icons.batteryIconBackground,
      img: {
        width: '12px',
        '${min.sm}': {
          width: '18px',
        },
      },
    },
  },
};

export default icons;
